import React, { useState } from "react";
import flightIcon from "../assets/icons/flight.svg";
import { MdLiveTv } from "react-icons/md";
import { MdPower } from "react-icons/md";
import { MdRestaurant } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import { FaDollarSign } from "react-icons/fa";
import { FaSyncAlt } from "react-icons/fa";
import Bag from "../assets/icons/bag.svg";
import Chair from "../assets/icons/chair.svg";
import Amenity from "../assets/icons/aminity.svg";
import { formatPrice } from "../utils/flightDataUtils";

function SingleRateCard(props) {
  const [showDetails, setShowDetails] = useState(false);
  const [showAmenityDropdown, setShowAmenityDropdown] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);

  // Resolve airline logo from props to match flight details
  const airlineImg = props.airlineImg || "/airline_logos/multi.png";

  // Create flight data from props
  const flight = {
    time: props.time || "09:10 - 18:00",
    route: props.route || "BLR Bengaluru Intl-SFO San Francisco",
    stops: props.flightType || "1 stop",
    stopAirport: "BOM",
    duration: props.duration || "21h 20m",
    airline: props.airlineName || "Air India",
    flightNumber: "AI 123",
    aircraft: "Airbus A320neo",
    departure: {
      time: props.time ? props.time.split(" – ")[0] : "09:10",
      airport: props.route ? props.route.split("-")[0] : "Bengaluru Intl (BLR)",
      code: props.route ? props.route.split("-")[0].split(" ").pop().replace(/[()]/g, "") : "BLR"
    },
    arrival: {
      time: props.time ? props.time.split(" – ")[1] : "18:00",
      airport: props.route ? props.route.split("-")[1] : "San Francisco (SFO)",
      code: props.route ? props.route.split("-")[1].split(" ").pop().replace(/[()]/g, "") : "SFO"
    },
    flightDuration: props.duration || "21h 20m"
  };

  const handleFlightDetailsClick = () => {
    setShowDetails(!showDetails);
  };

  const handleAmenityDropdownClick = (e) => {
    e.stopPropagation();
    setShowAmenityDropdown(!showAmenityDropdown);
  };

  return (
    <div style={{
      background: '#fff',
      borderRadius: 10,
      boxShadow: '0 2px 8px #dbe2ea',
      border: '1px solid #cfd8e3',
      padding: "0 8px",
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      overflow: 'hidden',
      margin: '8px 0',
    }}>

      {/* Best inline ad header (only for the very first card when Best is selected) */}
      {props.showBestHeader && (
        <div style={{
          display: 'flex',
          alignItems: 'stretch',
          backgroundColor: '#fff',
          border: '1px solid #E6EBEF',
          borderRadius: 10,
          margin: '10px 8px 6px',
          padding: '12px',
          gap: 16,
          position: 'relative'
        }}>
          {/* Left strip */}
          <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, backgroundColor: '#1a73e8', borderTopLeftRadius: 10, borderBottomLeftRadius: 10 }} />

          {/* Left: logo + text */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingLeft: 12, flex: 1 }}>
            <img
              src="./airline_logos/BA.png"
              alt="eDreams"
              style={{ height: 20, objectFit: 'contain' }}
            />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontWeight: 800, color: '#1b1f23', fontSize: 16 }}>Find the best deals on eDreams</div>
              <div style={{ color: '#667085', fontSize: 13 }}>Compare flights from more than 600 airlines</div>
            </div>
          </div>
          {/* Ad label */}
          <div style={{ position: 'absolute', right: 16, bottom: 8, color: '#6b7280', fontSize: 12 }}>Ad</div>
        </div>
      )}

      {/* Main Content */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 0, minHeight: '80px' }}>
        {/* Left: Flight Details */}
        <div style={{ flex: 2, padding: '8px 12px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          {/* Top Header Section */}
          <div style={{ padding: '2px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* Left Side - Action Buttons */}
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={props.onSave} style={{
                  border: '1px solid #9ba8b0',
                  background: '#f9fafb',
                  borderRadius: 4,
                  padding: '2px 6px',
                  fontWeight: 600,
                  fontSize: 11,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                  cursor: 'pointer'
                }}>
                  ♡ Save
                </button>
                <button onClick={props.onShare} style={{
                  border: '1px solid #9ba8b0',
                  background: '#f9fafb',
                  borderRadius: 4,
                  padding: '2px 6px',
                  fontWeight: 600,
                  fontSize: 11,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                  cursor: 'pointer'
                }}>
                  ⇪ Share
                </button>
              </div>
            </div>
          </div>

          {/* Flight Row - Centered */}
          <div 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              gap: '12px', 
              padding: '8px 12px',
              cursor: 'pointer',
              borderRadius: '6px',
              transition: 'all 0.2s ease',
              border: '1px solid transparent'
            }}
            onClick={handleFlightDetailsClick}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f8f9fa';
              e.currentTarget.style.borderColor = '#e3e7ea';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            {/* Airline Logo */}
            <img src={airlineImg} alt={props.airlineName || flight.airline} style={{ width: 36, height: 28, objectFit: 'contain' }} />

            {/* Flight Times & Route */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '2px', alignItems: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: '#222' }}>
                {flight.time}
              </div>
              <div style={{ fontSize: 12, color: '#666' }}>
                {flight.airline}
              </div>
            </div>

            {/* Stops & Stop Airport */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', minWidth: '50px' }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: '#222' }}>
                {flight.stops}
              </div>
              {flight.stops !== "nonstop" && (
                <div style={{ fontSize: 12, color: '#666' }}>
                  {flight.stopAirport}
                </div>
              )}
            </div>

            {/* Duration */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', minWidth: '70px' }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: '#222' }}>
                {flight.duration}
              </div>
              <div style={{ fontSize: 12, color: '#666' }}>
                {flight.route}
              </div>
            </div>
            
          
          </div>
        </div>

        {/* Pricing Cards */}
        <div style={{ display: 'flex', gap: '6px', padding: '8px 0' }}>
          {/* Left Card (Basic Economy) */}
          <div
            style={{
              background: hoveredCard === 'left' ? '#f8f9fa' : '#fff',
              borderRadius: '8px',
              border: "1px solid #cfd8e3",
              width: '140px',
              textAlign: 'start',
              boxShadow: hoveredCard === 'left' ? '0 4px 12px rgba(25, 118, 210, 0.15)' : '0 2px 8px rgba(0,0,0,0.05)',
              cursor: 'pointer',
            }}
            onMouseEnter={() => setHoveredCard('left')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div style={{ fontWeight: 700, fontSize: 20, color: '#222', marginBottom: '2px', marginLeft: "8px", marginTop: "6px" }}>
              {props.price1 || '£39'}
            </div>
            <div style={{ fontSize: 11, color: '#444', marginBottom: '6px', marginLeft: "8px" }}>
              Basic Economy
            </div>

            <button style={{
              background: 'linear-gradient(135deg,#ff690f 0%,#e8381b 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              fontWeight: 600,
              fontSize: 12,
              cursor: 'pointer',
              width: '85%',
              marginBottom: '8px',
              marginLeft: "8px",
              transition: 'none',
              transform: 'none'
            }}>
              {props.showBestHeader ? 'View deal' : 'Select'}
            </button>

            <hr style={{ margin: '6px 0', border: "1px solid #cfd8e3" }} />

            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <div>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15v-60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V85h15a15 15 0 0115 15v60a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5v-60a5 5 0 00-5-5H55a5 5 0 00-5 5v60a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm0-80h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 60a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5zm-50 0a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5z"></path></svg>
                <FaCheckCircle size={14} color="green" />
              </div>
              <div>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15V60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V45h15a15 15 0 0115 15v100a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5V60a5 5 0 00-5-5H80v12.93l8.54 8.53A5 5 0 0190 80v30a5 5 0 01-5 5h-5v25a5 5 0 01-10 0v-25h-5a5 5 0 01-5-5V80a5 5 0 011.46-3.54L70 67.93V55H55a5 5 0 00-5 5v100a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm-10-60h10V82.07l-5-5l-5 5zm10-60h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 100a5 5 0 01-5-5V80a5 5 0 0110 0v60a5 5 0 01-5 5z"></path></svg>
                <FaDollarSign size={14} color="#333" />
              </div>
              <div>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M135 180H75a5 5 0 010-10h25v-20H75a5 5 0 01-4.85-3.79l-10-39.89l-.06-.21l-10-39.9A4.89 4.89 0 0150 65V35a15 15 0 0130 0v29.38L88.9 100H145a5 5 0 010 10H91.4l2.5 10H135a15 15 0 0115 15v10a5 5 0 01-5 5h-35v20h25a5 5 0 010 10zm-30-40h35v-5a5 5 0 00-5-5H90a5 5 0 01-4.85-3.79L81.1 110h-9.7l7.5 30zm-36.1-40h9.7l-8.45-33.79A4.89 4.89 0 0170 65V35a5 5 0 00-10 0v29.38z"></path></svg>
                <FaSyncAlt size={14} color="green" />
              </div>
            </div>
          </div>

          {/* Right Card (Main Cabin) */}
          <div
            style={{
              background: hoveredCard === 'right' ? '#f8f9fa' : '#fff',
              borderRadius: '8px',
              border: "1px solid #cfd8e3",
              width: '140px',
              textAlign: 'start',
              boxShadow: hoveredCard === 'right' ? '0 4px 12px rgba(25, 118, 210, 0.15)' : '0 2px 8px rgba(0,0,0,0.05)',
              cursor: 'pointer',
            }}
            onMouseEnter={() => setHoveredCard('right')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div style={{ fontWeight: 700, fontSize: 20, color: '#222', marginBottom: '2px', marginLeft: "8px", marginTop: "6px" }}>
              {props.price2 || '£69'}
            </div>
            <div style={{ fontSize: 11, color: '#444', marginBottom: '6px', marginLeft: "8px" }}>
              Main Cabin
            </div>

            <button style={{
              background: 'linear-gradient(135deg,#ff690f 0%,#e8381b 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              fontWeight: 600,
              marginLeft: "8px",
              fontSize: 12,
              cursor: 'pointer',
              width: '85%',
              marginBottom: '8px',
              transition: 'none',
              transform: 'none'
            }}>
              {props.showBestHeader ? 'View deal' : 'Select'}
            </button>

            <hr style={{ margin: '6px 0' }} />

            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <div>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15v-60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V85h15a15 15 0 0115 15v60a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5v-60a5 5 0 00-5-5H55a5 5 0 00-5 5v60a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm0-80h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 60a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5zm-50 0a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5z"></path></svg>
                <FaCheckCircle size={14} color="green" />
              </div>
              <div>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15V60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V45h15a15 15 0 0115 15v100a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5V60a5 5 0 00-5-5H80v12.93l8.54 8.53A5 5 0 0190 80v30a5 5 0 01-5 5h-5v25a5 5 0 01-10 0v-25h-5a5 5 0 01-5-5V80a5 5 0 011.46-3.54L70 67.93V55H55a5 5 0 00-5 5v100a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm-10-60h10V82.07l-5-5l-5 5zm10-60h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 100a5 5 0 01-5-5V80a5 5 0 0110 0v60a5 5 0 01-5 5z"></path></svg>
                <FaDollarSign size={14} color="#333" />
              </div>
              <div>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M135 180H75a5 5 0 010-10h25v-20H75a5 5 0 01-4.85-3.79l-10-39.89l-.06-.21l-10-39.9A4.89 4.89 0 0150 65V35a15 15 0 0130 0v29.38L88.9 100H145a5 5 0 010 10H91.4l2.5 10H135a15 15 0 0115 15v10a5 5 0 01-5 5h-35v20h25a5 5 0 010 10zm-30-40h35v-5a5 5 0 00-5-5H90a5 5 0 01-4.85-3.79L81.1 110h-9.7l7.5 30zm-36.1-40h9.7l-8.45-33.79A4.89 4.89 0 0170 65V35a5 5 0 00-10 0v29.38z"></path></svg>
                <FaSyncAlt size={14} color="green" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Flight Details Section */}
      {showDetails && (
        <>
          {/* Container with light grey background */}
          <div style={{
            background: '#f8f9fa',
            padding: '16px',
            margin: '10px',
            borderRadius: '10px'
          }}>
            {/* Flight Card */}
            <div style={{
              background: '#fff',
              borderRadius: 10,
              boxShadow: '0 2px 8px #dbe2ea',
              border: '1px solid #cfd8e3',
              padding: "16px",
              marginBottom: '0'
            }}>
              {/* Flight Header */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
                padding: '0',
                borderBottom: '1px solid #dee2e6'
              }}>
                <div style={{ fontWeight: 600, fontSize: 16, color: '#333' }}>
                  {flight.departure.airport} to {flight.arrival.airport}
                </div>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#666' }}>
                  {flight.flightDuration}
                </div>
              </div>

              {/* Flight Segment */}
              <div style={{
                marginBottom: '0',
                position: 'relative'
              }}>
                {/* Flight Header */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '16px'
                }}>
                  <span style={{
                    color: '#0074d9',
                    fontWeight: 600,
                    fontSize: 14
                  }}>
                    {flight.airline}
                  </span>
                  <span style={{ fontSize: 12, color: '#5a6872' }}>
                    {flight.flightNumber}
                  </span>
                  <span style={{
                    color: '#666',
                    padding: '4px 12px',
                    borderRadius: '8px',
                    fontSize: 12,
                    fontWeight: 500,
                    border: "1px solid #cfd8e3",
                    marginLeft: "10px",
                  }}>
                    {flight.aircraft}
                  </span>

                  <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px', alignItems: 'center', position: 'relative' }}>
                    {/* Amenity Icons Container */}
                    {!showAmenityDropdown && <div style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                      padding: '10px 8px',
                      background: '#f5f5f5',
                      borderRadius: '16px'
                    }}>
                      <span style={{ fontSize: 14, color: '#333' }} title="Wi-Fi">
                        📶
                      </span>
                      <span style={{ fontSize: 14, color: '#333' }} title="In-flight entertainment">
                        <MdLiveTv />
                      </span>
                      <span style={{ fontSize: 14, color: '#333' }} title="Food service">
                        <MdRestaurant />
                      </span>
                      <span
                        style={{
                          fontSize: 12,
                          color: '#666',
                          cursor: 'pointer',
                          marginLeft: '4px',
                          transform: showAmenityDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.2s'
                        }}
                        title="More details"
                        onClick={handleAmenityDropdownClick}
                      >
                        ▼
                      </span>
                    </div>}

                    {/* Amenity Dropdown */}
                    {showAmenityDropdown && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        background: '#f5f5f5',
                        borderRadius: '6px',
                        padding: '8px',
                        marginTop: '4px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        zIndex: 10,
                        minWidth: '200px'
                      }}>
                        <div style={{
                          position: 'absolute',
                          top: '-4px',
                          right: '12px',
                          width: '8px',
                          height: '8px',
                          background: '#f5f5f5',
                          transform: 'rotate(45deg)'
                        }}></div>
                        <div style={{ position: "absolute", top: 0, right: 10, fontSize: 10, color: '#666', cursor: 'pointer' }}
                          onClick={handleAmenityDropdownClick}
                        >▲</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: 14, color: '#333' }}>📶</span>
                            <span style={{ fontSize: 12, color: '#333' }}>Wi-Fi available</span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: 14, color: '#333' }}><MdLiveTv /></span>
                            <span style={{ fontSize: 12, color: '#333' }}>Streaming entertainment</span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: 14, color: '#333' }}><MdRestaurant /></span>
                            <span style={{ fontSize: 12, color: '#333' }}>Meal provided</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Vertical Timeline Layout */}
                <div style={{
                  position: 'relative',
                  paddingLeft: '30px'
                }}>
                  {/* Timeline Line */}
                  <div style={{
                    position: 'absolute',
                    left: '14px',
                    top: '0',
                    bottom: '0',
                    width: '2px',
                    background: '#ddd'
                  }}></div>

                  {/* Departure */}
                  <div style={{
                    position: 'relative',
                    marginBottom: '16px'
                  }}>
                    {/* Timeline Circle */}
                    <div style={{
                      position: 'absolute',
                      left: '-21px',
                      top: '0px',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      border: '2px solid #ddd',
                      background: '#fff'
                    }}></div>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                      <div style={{ fontWeight: 700, fontSize: 18, color: '#333' }}>
                        {flight.departure.time}
                      </div>
                      <div style={{ fontSize: 16, color: '#666', fontWeight: 500, marginLeft: "30px" }}>
                        {flight.departure.airport} ({flight.departure.code})
                      </div>
                    </div>
                  </div>

                  {/* Flight Duration with Airplane */}
                  <div style={{
                    position: 'relative',
                    marginBottom: '16px',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    {/* Airplane Icon */}
                    <div style={{
                      position: 'absolute',
                      left: '-26px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontSize: '16px'
                    }}>
                      <img src={flightIcon} alt="flight" />
                    </div>

                    <div style={{ fontSize: 14, color: '#666' }}>
                      {flight.duration}
                    </div>
                  </div>

                  {/* Arrival */}
                  <div style={{
                    position: 'relative',
                    marginBottom: '8px'
                  }}>
                    {/* Timeline Circle */}
                    <div style={{
                      position: 'absolute',
                      left: '-21px',
                      top: '12px',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      border: '2px solid #ddd',
                      background: '#fff'
                    }}></div>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                      <div style={{ fontWeight: 700, fontSize: 18, color: '#333' }}>
                        {flight.arrival.time}
                      </div>
                      <div style={{ fontSize: 16, color: '#666', fontWeight: 500, marginLeft: "30px" }}>
                        {flight.arrival.airport} ({flight.arrival.code})
                      </div>
                    </div>
                  </div>

                  {/* Layover Information - Only show if there are stops */}
                  {flight.stops !== "nonstop" && (
                    <div style={{
                      padding: '8px 0',
                      margin: '8px 0',
                      fontSize: 12,
                      color: '#666',
                      fontWeight: 500,
                      textAlign: 'center',
                      borderBottom: "1px solid #cfd8e3",
                      borderTop: "1px solid #cfd8e3",
                    }}>
                      {flight.stops} • Change planes in {flight.stopAirport}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Price Details Section */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
            borderTop: '1px solid #e9ecef',
            background: '#fff'
          }}>
            {/* Left side - Empty for now */}
            <div style={{ flex: 1 }}></div>

            {/* Right side - Pricing and Select Button */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              {/* Deal Count */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: '2px'
              }}>
                <div style={{
                  fontSize: 12,
                  color: '#666',
                  fontWeight: 400
                }}>
                  2 deals from
                </div>

                {/* Price with Info Icon */}
                <div
                  style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '6px' }}
                  onMouseEnter={() => setShowPriceBreakdown(true)}
                  onMouseLeave={() => setShowPriceBreakdown(false)}
                >
                  <div style={{
                    width: '14px',
                    height: '14px',
                    borderRadius: '50%',
                    border: '1px solid #333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 10,
                    fontWeight: 600,
                    color: '#333',
                    cursor: 'default'
                  }}>
                    i
                  </div>
                  <div style={{
                    fontSize: 18,
                    fontWeight: 700,
                    color: '#222'
                  }}>
                    {props.price1}
                  </div>

                  {showPriceBreakdown && (
                    <div style={{
                      position: 'absolute',
                      right: 0,
                      bottom: 'calc(100% + 12px)',
                      width: 340,
                      background: '#fff',
                      border: '1px solid #e6e8eb',
                      borderRadius: 12,
                      boxShadow: '0 12px 28px rgba(0,0,0,0.16)',
                      zIndex: 50,
                      overflow: 'hidden'
                    }}>
                      <div style={{ position: 'absolute', right: '18px', top: '100%', width: 14, height: 14, background: '#fff', borderLeft: '1px solid #e6e8eb', borderBottom: '1px solid #e6e8eb', transform: 'translateY(-2px) rotate(45deg)' }} />

                      <div style={{ padding: '16px 18px' }}>
                        <div style={{ fontWeight: 700, fontSize: 18, color: '#111827', marginBottom: 12 }}>Price breakdown</div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 7a2 2 0 012-2h10l6 6v6a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" stroke="#111827" strokeWidth="1.5"/></svg>
                            <span style={{ color: '#374151', fontSize: 14 }}>Ticket price</span>
                          </div>
                          <div style={{ color: '#111827', fontWeight: 700, fontSize: 14 }}>{props.price1 || '$0'}</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <img src={Bag} alt="Carry-on bag" style={{ width: 16, height: 16, filter: 'grayscale(100%) contrast(120%)' }} />
                            <span style={{ color: '#374151', fontSize: 14 }}>Carry-on bag</span>
                          </div>
                          <div style={{ color: '#111827', fontWeight: 700, fontSize: 14 }}>Included</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <img src={Bag} alt="Checked bag" style={{ width: 16, height: 16, filter: 'grayscale(100%) contrast(120%)' }} />
                            <span style={{ color: '#374151', fontSize: 14 }}>Checked bag</span>
                          </div>
                          <div style={{ textAlign: 'right', color: '#374151' }}>
                            <div style={{ fontWeight: 700, fontSize: 14 }}>Not Included</div>
                            <div style={{ fontSize: 13, color: '#6b7280' }}>(+$70)</div>
                          </div>
                        </div>

                        <div style={{ color: '#6b7280', fontSize: 12, marginTop: 10 }}>Up to 50lbs per bag • Up to 62in total</div>

                        <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '14px 0' }} />

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div style={{ color: '#111827', fontWeight: 700, fontSize: 15 }}>Total</div>
                          <div style={{ color: '#111827', fontWeight: 700, fontSize: 15 }}>{props.price1 || '$0'}</div>
                        </div>
                      </div>

                      <div style={{ background: '#f5f7f8', borderTop: '1px solid #e6e8eb', padding: '12px 18px', fontSize: 12, color: '#6b7280' }}>
                        *Baggage fees may be estimated and vary across booking sites.
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Select Button */}
              <button style={{
                background: 'linear-gradient(90deg, #ff690f 0%, #ff8800 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                padding: '10px 20px',
                fontWeight: 600,
                fontSize: 14,
                cursor: 'pointer',
                transition: 'none',
                boxShadow: '0 2px 4px rgba(255, 105, 15, 0.3)'
              }}>
                {props.showBestHeader ? 'View deal' : 'Select'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SingleRateCard; 